import { render, staticRenderFns } from "./seeDemand.vue?vue&type=template&id=0a84636e&scoped=true&"
import script from "./seeDemand.vue?vue&type=script&lang=js&"
export * from "./seeDemand.vue?vue&type=script&lang=js&"
import style0 from "./seeDemand.vue?vue&type=style&index=0&id=0a84636e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a84636e",
  null
  
)

export default component.exports